(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onovo-announcement-marquee"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('onovo-announcement-marquee')){
  customElements.define('onovo-announcement-marquee',class extends HTMLElement{
    connectedCallback(){
      const group=this.querySelector('.ona-group');
      if(!group)return;
      this.measure=()=>{
        const width=group.getBoundingClientRect().width;
        if(!width)return;
        const count=Math.max(2,Math.ceil(this.clientWidth/width)+2);
        const track=this.querySelector('.ona-track');
        while(track.children.length<count){const clone=group.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.setAttribute('inert','');track.append(clone);}
        while(track.children.length>count)track.lastElementChild.remove();
        if(this.distance===width)return;
        this.distance=width;
        this.style.setProperty('--ona-distance',width+'px');
        this.style.setProperty('--ona-duration',width/(Number(this.dataset.speed)||32)+'s');
        this.setAttribute('data-ready','');
      };
      this.observer=new ResizeObserver(this.measure);
      this.observer.observe(group);
      this.observer.observe(this);
      this.measure();
      document.fonts.ready.then(()=>{if(this.isConnected)this.measure();});
    }
    disconnectedCallback(){this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onovo-banner-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onovo-banner-slider')) {
    customElements.define('onovo-banner-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.handleClick = event => {
          if (event.target.closest('[data-prev]')) this.go(this.index - 1, true);
          if (event.target.closest('[data-next]')) this.go(this.index + 1, true);
          const dot = event.target.closest('[data-dot]');
          if (dot) this.go(Number(dot.dataset.dot), true);
        };
        this.handleKey = event => {
          if (event.target.matches('a, button, input, textarea, select')) return;
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1, true); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1, true); }
        };
        this.handleVisibility = () => { if (document.hidden) this.stop(); else this.start(); };
        this.handleBlockSelect = event => {
          const slide = this.slides.find(item => item.dataset.blockId === event.detail.blockId);
          if (slide) { this.stop(); this.go(this.slides.indexOf(slide), false); }
        };
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKey);
        this.addEventListener('mouseenter', this.stopBound = () => this.stop());
        this.addEventListener('mouseleave', this.startBound = () => this.start());
        this.addEventListener('focusin', this.stopBound);
        this.addEventListener('focusout', this.startBound);
        document.addEventListener('visibilitychange', this.handleVisibility);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.start();
      }
      disconnectedCallback() {
        this.stop();
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKey);
        this.removeEventListener('mouseenter', this.stopBound);
        this.removeEventListener('mouseleave', this.startBound);
        this.removeEventListener('focusin', this.stopBound);
        this.removeEventListener('focusout', this.startBound);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }
      start() {
        this.stop();
        if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
        this.timer = window.setInterval(() => this.go(this.index + 1, false), Math.max(2500, Number(this.dataset.interval) || 6000));
      }
      stop() { window.clearInterval(this.timer); }
      go(next, announce) {
        if (this.slides.length < 2) return;
        const nextIndex = (next + this.slides.length) % this.slides.length;
        if (nextIndex === this.index) return;
        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.slides[this.index].setAttribute('inert', '');
        this.dots[this.index]?.classList.remove('is-active');
        this.dots[this.index]?.setAttribute('aria-current', 'false');
        this.index = nextIndex;
        this.slides[this.index].classList.add('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'false');
        this.slides[this.index].removeAttribute('inert');
        this.dots[this.index]?.classList.add('is-active');
        this.dots[this.index]?.setAttribute('aria-current', 'true');
        if (announce) this.querySelector('[data-status]').textContent = `Slide ${this.index + 1} nga ${this.slides.length}`;
        if (announce) this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onovo-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onovo-faq')) {
    customElements.define('onovo-faq', class extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('.onovo-faq__item');
        const desired = new WeakMap();
        const running = new WeakMap();
        const duration = Number(this.dataset.duration) || 360;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const setOpen = (item, open) => {
          const previousHeight = item.getBoundingClientRect().height;
          running.get(item)?.cancel();
          desired.set(item, open);
          if (reducedMotion.matches) {
            item.open = open;
            item.style.height = '';
            item.style.overflow = '';
            item.removeAttribute('data-closing');
            return;
          }
          item.style.height = `${previousHeight}px`;
          item.style.overflow = 'hidden';
          if (open) { item.removeAttribute('data-closing'); item.open = true; }
          else item.dataset.closing = 'true';
          const targetHeight = open ? item.scrollHeight : item.querySelector('summary').offsetHeight;
          const animation = item.animate(
            [{ height: `${previousHeight}px` }, { height: `${targetHeight}px` }],
            { duration, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          );
          running.set(item, animation);
          const answer = item.querySelector('.onovo-faq__answer');
          if (answer) {
            answer.getAnimations().forEach(active => active.cancel());
            answer.animate(
              open ? [{ opacity: .35, transform: 'translateY(-5px)' }, { opacity: 1, transform: 'translateY(0)' }]
                   : [{ opacity: 1, transform: 'translateY(0)' }, { opacity: .3, transform: 'translateY(-4px)' }],
              { duration: Math.min(duration, 300), easing: 'ease-out' }
            );
          }
          animation.onfinish = () => {
            if (running.get(item) !== animation) return;
            item.open = open;
            item.style.height = '';
            item.style.overflow = '';
            item.removeAttribute('data-closing');
            running.delete(item);
          };
        };
        items.forEach(item => item.querySelector('summary')?.addEventListener('click', event => {
          event.preventDefault();
          const currentlyOpen = desired.has(item) ? desired.get(item) : item.open;
          const nextOpen = !currentlyOpen;
          if (nextOpen && this.dataset.oneOpen === 'true') {
            items.forEach(other => { if (other !== item && (desired.has(other) ? desired.get(other) : other.open)) setOpen(other, false); });
          }
          setOpen(item, nextOpen);
        }));
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.onovo-faq__item');
          if (item && !(desired.has(item) ? desired.get(item) : item.open)) setOpen(item, true);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onovo-home-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onovo-home-slider')) {
    customElements.define('onovo-home-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.handleClick = event => {
          if (event.target.closest('[data-prev]')) this.go(this.index - 1, true);
          if (event.target.closest('[data-next]')) this.go(this.index + 1, true);
          const dot = event.target.closest('[data-dot]');
          if (dot) this.go(Number(dot.dataset.dot), true);
        };
        this.handleKey = event => {
          if (event.target.matches('a, button, input, textarea, select')) return;
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1, true); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1, true); }
        };
        this.handleVisibility = () => { if (document.hidden) this.stop(); else this.start(); };
        this.handleBlockSelect = event => {
          const slide = this.slides.find(item => item.dataset.blockId === event.detail.blockId);
          if (slide) { this.stop(); this.go(this.slides.indexOf(slide), false); }
        };
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKey);
        this.addEventListener('mouseenter', this.stopBound = () => this.stop());
        this.addEventListener('mouseleave', this.startBound = () => this.start());
        this.addEventListener('focusin', this.stopBound);
        this.addEventListener('focusout', this.startBound);
        document.addEventListener('visibilitychange', this.handleVisibility);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.start();
      }
      disconnectedCallback() {
        this.stop();
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKey);
        this.removeEventListener('mouseenter', this.stopBound);
        this.removeEventListener('mouseleave', this.startBound);
        this.removeEventListener('focusin', this.stopBound);
        this.removeEventListener('focusout', this.startBound);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }
      start() {
        this.stop();
        if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
        this.timer = window.setInterval(() => this.go(this.index + 1, false), Math.max(2500, Number(this.dataset.interval) || 6000));
      }
      stop() { window.clearInterval(this.timer); }
      go(next, announce) {
        if (this.slides.length < 2) return;
        const nextIndex = (next + this.slides.length) % this.slides.length;
        if (nextIndex === this.index) return;
        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.slides[this.index].setAttribute('inert', '');
        this.dots[this.index]?.classList.remove('is-active');
        this.dots[this.index]?.setAttribute('aria-current', 'false');
        this.index = nextIndex;
        this.slides[this.index].classList.add('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'false');
        this.slides[this.index].removeAttribute('inert');
        this.dots[this.index]?.classList.add('is-active');
        this.dots[this.index]?.setAttribute('aria-current', 'true');
        if (announce) this.querySelector('[data-status]').textContent = `Slide ${this.index + 1} nga ${this.slides.length}`;
        if (announce) this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onovo-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onovo-video-reviews')) {
    customElements.define('onovo-video-reviews', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('.ovr__track');
        if (!track) return;
        const slides = [...track.querySelectorAll('.ovr__slide')];
        const dots = [...this.querySelectorAll('.ovr__dot')];
        const prev = this.querySelector('.ovr__arrow--prev');
        const next = this.querySelector('.ovr__arrow--next');
        const loop = this.dataset.loop === 'true';
        let current = 0;
        let timer;
        let productObserver;
        if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          productObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); productObserver.unobserve(entry.target); } });
          }, { threshold: 0.15 });
          this.querySelectorAll('.ovr__product').forEach(product => { product.classList.add('ovr__product--ready'); productObserver.observe(product); });
        }
        const pauseAll = (except) => {
          this.querySelectorAll('video').forEach(video => { if (video !== except) { video.pause(); const button = video.closest('.ovr__slide')?.querySelector('.ovr__play'); button?.setAttribute('aria-label', 'Luaj videon'); button?.removeAttribute('data-playing'); } });
          this.querySelectorAll('.ovr__embed iframe').forEach(frame => { if (!except || !frame.closest('.ovr__slide')?.contains(except)) { frame.closest('.ovr__slide')?.querySelector('.ovr__play')?.removeAttribute('hidden'); frame.remove(); } });
        };
        const update = () => {
          if (!slides.length) return;
          current = slides.reduce((best, slide, index) => Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - track.offsetLeft - track.scrollLeft) ? index : best, 0);
          dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
          if (prev) prev.disabled = !loop && current === 0;
          if (next) next.disabled = !loop && (track.scrollLeft + track.clientWidth >= track.scrollWidth - 3);
        };
        const go = index => {
          if (!slides.length) return;
          if (loop) index = (index + slides.length) % slides.length;
          else index = Math.max(0, Math.min(slides.length - 1, index));
          pauseAll();
          track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          current = index;
          dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
        };
        prev?.addEventListener('click', () => go(current - 1));
        next?.addEventListener('click', () => go(current + 1));
        dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
        let frame;
        track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, { passive: true });
        this.querySelectorAll('.ovr__slide').forEach(slide => {
          const play = slide.querySelector('.ovr__play');
          const mute = slide.querySelector('.ovr__mute');
          const video = slide.querySelector('video');
          const embed = slide.querySelector('.ovr__embed');
          const syncPlay = () => {
            if (!video || !play) return;
            if (video.paused) { play.removeAttribute('data-playing'); play.setAttribute('aria-label', 'Luaj videon'); }
            else { play.dataset.playing = 'true'; play.setAttribute('aria-label', 'Ndalo videon'); }
          };
          const syncSound = () => {
            if (!video || !mute) return;
            const audible = !video.muted && video.volume > 0;
            mute.dataset.sound = audible ? 'on' : 'off';
            mute.setAttribute('aria-pressed', String(audible));
            mute.setAttribute('aria-label', audible ? 'Hiq zërin' : 'Aktivizo zërin');
          };
          video?.addEventListener('play', syncPlay);
          video?.addEventListener('pause', syncPlay);
          video?.addEventListener('volumechange', syncSound);
          syncPlay(); syncSound();
          play?.addEventListener('click', async () => {
            if (video) {
              if (!video.paused) { video.pause(); return; }
              pauseAll(video);
              try { await video.play(); } catch { syncPlay(); }
            } else if (embed?.dataset.embed) {
              pauseAll();
              const iframe = document.createElement('iframe');
              iframe.src = embed.dataset.embed.replaceAll('&amp;', '&');
              iframe.title = slide.querySelector('.ovr__author')?.textContent || 'Video review';
              iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
              iframe.allowFullscreen = true;
              embed.append(iframe);
              play.hidden = true;
            }
          });
          video?.addEventListener('ended', syncPlay);
          mute?.addEventListener('click', () => {
            video.muted = !video.muted;
            syncSound();
          });
        });
        const start = () => {
          if (this.dataset.auto !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches || slides.length < 2) return;
          clearInterval(timer);
          timer = setInterval(() => { if (![...this.querySelectorAll('video')].some(video => !video.paused) && !this.querySelector('.ovr__embed iframe')) go(current + 1); }, Number(this.dataset.interval) || 6000);
        };
        this.addEventListener('mouseenter', () => clearInterval(timer));
        this.addEventListener('mouseleave', start);
        this.addEventListener('focusin', () => clearInterval(timer));
        this.addEventListener('focusout', start);
        this.addEventListener('shopify:block:select', event => { const selected = slides.indexOf(event.target.closest('.ovr__slide')); if (selected >= 0) go(selected); });
        this._cleanup = () => { clearInterval(timer); cancelAnimationFrame(frame); productObserver?.disconnect(); pauseAll(); };
        update(); start();
      }
      disconnectedCallback() { this._cleanup?.(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onovo-wellness-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!window.__onovoTimelineScroll) {
    window.__onovoTimelineScroll = true;
    let frame = 0;
    const update = () => {
      frame = 0;
      document.querySelectorAll('[data-ow-timeline]').forEach((section) => {
        const steps = [...section.querySelectorAll('.ow-timeline__step')];
        const rail = section.querySelector('.ow-timeline__rail');
        if (!rail || steps.length < 2) return;
        const first = steps[0].getBoundingClientRect().top + 8;
        const last = steps[steps.length - 1].getBoundingClientRect().top + 8;
        const line = Math.max(1, last - first);
        rail.style.height = `${Math.max(0, steps[steps.length - 1].offsetTop - steps[0].offsetTop)}px`;
        const marker = window.innerHeight * 0.62;
        const progress = Math.max(0, Math.min(1, (marker - first) / line));
        rail.style.setProperty('--ow-line-fill', `${progress * 100}%`);
        steps.forEach((step) => {
          step.classList.toggle('is-active', step.getBoundingClientRect().top + 8 <= marker);
        });
      });
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
    else schedule();
  }

  } catch(e) { console.error(e); }
})();
})();
